import React from "react";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  Icon,
  Text,
  Flex,
} from "@chakra-ui/react";
import { Plus, Square } from "lucide-react";
import { useTranslation } from "react-i18next";
import { CoordinatesType } from "../types/";

interface LocationCreateMenuProps {
  onCreateLocation: (type: CoordinatesType) => void;
}

export const LocationCreateMenu: React.FC<LocationCreateMenuProps> = ({
  onCreateLocation,
}) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "locations",
  });

  return (
    <Menu>
      <MenuButton
        as={Button}
        leftIcon={<Icon as={Plus} />}
        color="white"
        bg="#086AA9"
        _hover={{ bg: "rgba(40, 103, 149, 0.8)" }}
        _expanded={{ bg: "rgba(40, 103, 149, 0.8)" }}
      >
        <Text mt="3px">{t("createLocation")}</Text>
      </MenuButton>
      <MenuList color="#52525B" fontWeight={500}>
        <MenuItem
          onClick={() => onCreateLocation(CoordinatesType.AREA)}
          _hover={{ backgroundColor: "#EDF2F7" }}
        >
          <Flex gap={"10px"}>
            <Square size="16px" />
            {t("area")}
          </Flex>
        </MenuItem>
      </MenuList>
    </Menu>
  );
};
